.actionBar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 24px;
}

.basicInfo {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.cover {
  flex-shrink: 0;
  width: 48px;
  height: 64px;
  object-fit: cover;
  background: var(--ant-color-fill-secondary);
  border-radius: var(--ant-border-radius-sm);
}

.title {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 600;
  color: var(--ant-color-text-heading);
}

.code {
  margin-bottom: 4px;
  font-family: Monaco, Menlo, 'Ubuntu Mono', monospace;
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
}

.hook {
  font-size: 12px;
  line-height: 1.4;
  color: var(--ant-color-text-secondary);
}

.deleteWarning {
  white-space: pre-line;
}
